import { Input, Label } from '@/components/ui'
import { cn } from '@/lib/utils'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { MAX_REMINDER_WEEKS_BEFORE } from '../../util/NotificationSettings/reminder-weeks'

interface DriverCardReminderSettingProps {
  value: string
  invalid: boolean
  onChange: (value: string) => void
}

export const DriverCardReminderSetting: React.FC<
  DriverCardReminderSettingProps
> = ({ value, invalid, onChange }) => {
  const translations = useTranslate({
    label: 'settings.notifications.driver-card-reminder-label',
    suffix: 'settings.notifications.driver-card-reminder-suffix',
    help: 'settings.notifications.driver-card-reminder-help',
    invalid: 'settings.errors.driver-card-reminder-weeks',
  })

  return (
    <div className="mt-6 flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-3 text-sm text-neutral-700">
        <Label htmlFor="driver-card-reminder-weeks">{translations.label}</Label>
        <div className="w-20">
          <Input
            id="driver-card-reminder-weeks"
            type="number"
            inputMode="numeric"
            min={1}
            max={MAX_REMINDER_WEEKS_BEFORE}
            step={1}
            value={value}
            aria-invalid={invalid}
            className={cn('px-3 py-2 text-sm', invalid && 'border-red-700')}
            onChange={onChange}
          />
        </div>
        <span>{translations.suffix}</span>
      </div>
      <p
        className={cn('text-xs', invalid ? 'text-red-700' : 'text-neutral-500')}
      >
        {invalid ? translations.invalid : translations.help}
      </p>
    </div>
  )
}
